<template>
  <div class="allside">
    <div class="titbox">
      <img
        class="square"
        src="@/assets/image/tit-left.png"
        alt=""
      >
      <p>
        <span>陈伊洋</span>
        七年级（3班）
      </p>
      <img
        class="square"
        src="@/assets/image/tit-right.png"
        alt=""
      >
    </div>
    <div class="main">
      <img
        class="square"
        src="@/assets/image/square.png"
        alt=""
      >
      <h1>心理画像</h1>
      <div class="iconbox">
        <div class="textbox">
          <span class="green swim">强迫</span>
          <span class="green swim">敌对</span>
          <span class="green swim">孤独</span>
          <span
            class="swim"
            :class="[preintervention ? 'red' : 'yellow']"
          >焦虑</span>
          <span class="green swim">恐惧</span>
          <span class="yellow swim">抑郁</span>
          <span
            class="swim"
            :class="[preintervention ? 'red' : 'yellow']"
          >适应不良</span>
          <span class="green swim">偏执</span>
          <span class="orange swim">睡眠</span>
          <span class="orange swim">饮食</span>
        </div>
      </div>
      <div class="levelbox">
        <i class="red" />
        <p>三级预警</p>
        <i class="orange" />
        <p>二级预警</p>
        <i class="yellow" />
        <p>一级预警</p>
        <i class="green" />
        <p>正常</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    preintervention: {
      type: Boolean
    } //  true干预前 false干预后
  },
  data () {
    return {

    }
  },
  computed: {
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.allside {
  padding: 0 57px 30px;
}
.titbox {
  width: 750px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 24px 0 103px 0;
  img {
    width: 124px;
    height: 16px;
  }
  p {
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    line-height: 20px;
    span {
      font-weight: bold;
      margin-right: 10px;
    }
  }
}
.main {
  width: 750px;
  height: 467px;
  position: relative;
  margin-top: 50px;
  background: url("../assets/image/quanquan.png") no-repeat 0 0/100% 100%;
  display: flex;
  justify-content: center;
  .square {
    width: 425px;
    height: 338px;
  }
  h1 {
    font-weight: normal;
    color: #e7fdff;
    line-height: 34px;
    font-size: 28px;
    position: absolute;
    top: 100px;
    left: 316px;
  }
  .iconbox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    h1 {
      text-align: center;
      font-weight: normal;
      color: #e7fdff;
      line-height: 34px;
      font-size: 28px;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    }
    span {
      width: 68px;
      height: 68px;
      border-radius: 50%;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 15px;

      &.swim {
        font-size: 18px;
      }

      &.green {
        background: rgba(93, 209, 96, 0.8);
        border: 1px solid #5dd160;
      }
      &.orange {
        background: rgba(255, 138, 88, 0.8);
        border: 1px solid #e9703e;
      }
      &.yellow {
        background: rgba(215, 215, 19, 0.8);
        border: 1px solid #d7d713;
      }
      &.red {
        background: rgba(232, 74, 97, 0.8);
        border: 1px solid #e84a61;
      }
      &:nth-child(1) {
        position: absolute;
        top: -25px;
        right: 255px;
        animation: swim1 1s ease-out infinite alternate;
      }
      &:nth-child(2) {
        position: absolute;
        top: 16px;
        right: 126px;
        animation: swim2 1s ease-out infinite alternate;
      }
      &:nth-child(3) {
        position: absolute;
        top: 132px;
        right: 75px;
        animation: swim3 1s ease-out infinite alternate;
      }
      &:nth-child(4) {
        position: absolute;
        bottom: 136px;
        right: 55px;
        animation: swim4 1s ease-out infinite alternate;
      }
      &:nth-child(5) {
        position: absolute;
        bottom: 72px;
        right: 207px;
        animation: swim5 1s ease-out infinite alternate;
      }
      &:nth-child(6) {
        position: absolute;
        bottom: 59px;
        left: 289px;
        animation: swim6 1s ease-out infinite alternate;
      }
      &:nth-child(7) {
        position: absolute;
        bottom: 116px;
        left: 130px;
        animation: swim7 1s ease-out infinite alternate;
      }
      &:nth-child(8) {
        position: absolute;
        top: 176px;
        left: 56px;
        animation: swim8 1s ease-out infinite alternate;
      }
      &:nth-child(9) {
        position: absolute;
        top: 52px;
        left: 127px;
        animation: swim9 1s ease-out infinite alternate;
      }
      &:nth-child(10) {
        position: absolute;
        top: -43px;
        left: 248px;
        animation: swim10 1s ease-out infinite alternate;
      }
    }
  }
  .levelbox {
    position: absolute;
    bottom: -30px;
    right: -40px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: #fff;
    font-size: 12px;
    i {
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      &.red {
        background: #ff7575;
      }
      &.orange {
        background: #ff9200;
      }
      &.yellow {
        background: #f4c249;
      }
      &.green {
        background: #64d259;
      }
    }
    p {
      margin: 0 10px 0 7px;
    }
  }
}

@keyframes swim1 {
  0% {
    top: -30px;
  }
  100% {
    top: -20px;
  }
}
@keyframes swim2 {
  0% {
    top: 11px;
  }
  100% {
    top: 21px;
  }
}
@keyframes swim3 {
  0% {
    top: 127px;
  }
  100% {
    top: 137px;
  }
}
@keyframes swim4 {
  0% {
    bottom: 131px;
  }
  100% {
    bottom: 141px;
  }
}
@keyframes swim5 {
  0% {
    bottom: 67px;
  }
  100% {
    bottom: 77px;
  }
}
@keyframes swim6 {
  0% {
    bottom: 54px;
  }
  100% {
    bottom: 64px;
  }
}
@keyframes swim7 {
  0% {
    bottom: 111px;
  }
  100% {
    bottom: 121px;
  }
}
@keyframes swim8 {
  0% {
    top: 171px;
  }
  100% {
    top: 181px;
  }
}
@keyframes swim9 {
  0% {
    top: 47px;
  }
  100% {
    top: 57px;
  }
}
@keyframes swim10 {
  0% {
    top: -48px;
  }
  100% {
    top: -38px;
  }
}
</style>
